import React, { useState, useEffect } from 'react'
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

export default function Calendar(props) {

    const { calendar } = props

    const navigate = useNavigate()

    const [calModal, setCalModal] = useState(false)
    const [calData, setCalData] = useState()

    // const handleDateClick = (arg) => {
    //     alert(arg.dateStr);
    // };

    // function renderEventContent(eventInfo) {
    //     return (
    //         <>
    //             <b>{eventInfo.timeText}</b>
    //             <i>{eventInfo.events.title}</i>
    //         </>
    //     );
    // }

    const combineDateTime = (dateString, timeString) => {
        const [year, month, day] = dateString.split('-');
        const [hours, minutes] = timeString.split(':');

        const combinedDate = new Date(year, month - 1, day, hours, minutes);

        // Format the combined date as a string
        const formattedDate = combinedDate.toISOString();
        return formattedDate;
    };

    const events = calendar && calendar.map(value => ({
        backgroundColor: value.attendence_status == 'pending' ? 'yellow' : value.attendence_status == 'completed' ? 'green' : value.attendence_status == 'rejected' ? 'red' : '',
        title: value.training_title.length > 10 ? `${value.training_title.substring(0, 10)}...` : value.training_title,
        start: combineDateTime(value.start_date, value.start_time),
        training_title: value.training_title,
        start_date: value.start_date,
        start_time: value.start_time,
        end_date: value.end_date,
        end_time: value.end_time,
        training_id: value.id,
    }))

    // const handleEventContent = (arg) => {
    //     // Customize the event rendering to display the full title with ellipsis
    //     return (
    //         <div className='event-content'>
    //             <strong>{truncateTitle(arg.timeText + arg.event.title)}</strong>
    //         </div>
    //     );
    // }

    // const truncateTitle = (title, maxLength = 15) => {
    //     // Truncate the title if it exceeds the specified maxLength
    //     return title.length > maxLength ? `${title.substring(0, maxLength)}...` : title;
    // };

    const handleEventClick = (arg) => {
        setCalData(arg.event)
        setCalModal(true)
    }

    const handleClose = () => {
        setCalModal(false)
        setCalData()
    }

    const training_details = (params) => {
        navigate('/training_details', { state: { 'id': calData && calData.extendedProps && calData.extendedProps.training_id } })
    }

    return (
        <>
            <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin]}
                initialView='dayGridMonth'
                headerToolbar={{
                    left: "title",
                    // center: "title",
                    right: 'prev next'
                }}
                height={500}
                weekends={true}
                events={events}
                // eventContent={handleEventContent}
                eventClick={handleEventClick}
                // dayMaxEvents={true}
                dayMaxEventRows={2}
                // eventContent={renderEventContent}
                // eventContent={renderEventContent}
                // className='avaibility_calender'
                firstDay={1}
            />

            <Modal show={calModal} onHide={handleClose} backdrop="static" size='sm' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Event Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div>
                        <div className='mb-2'>
                            <strong>Title</strong> <br />
                            {calData && calData.extendedProps && calData.extendedProps.training_title}
                        </div>

                        <div className='mb-2'>
                            <strong>Start</strong> <br />
                            {`${calData?.extendedProps?.start_date && moment(calData?.extendedProps?.start_date).format('DD/MM/YYYY')}
                            ${calData && calData.extendedProps && calData.extendedProps.start_time}`}
                        </div>

                        <div className='mb-2'>
                            <strong>End</strong> <br />
                            {`${calData?.extendedProps?.end_date && moment(calData?.extendedProps?.end_date).format('DD/MM/YYYY')}
                            ${calData && calData.extendedProps && calData.extendedProps.end_time}`}
                        </div>

                        <button className='btn btn_submit' type='button' onClick={() => training_details()}>More Details</button>

                    </div>

                </Modal.Body>

            </Modal>
        </>
    )
}
